import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./components/Dashboard";
import RegulationDetail from "./components/RegulationDetail";
import TracingPath from "./components/TracingPath";
import TopicNavigator from "./components/TopicNavigator";

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/regulations/:id" element={<RegulationDetail />} />
        <Route path="/trace/:id" element={<TracingPath />} />
        <Route path="/topics" element={<TopicNavigator />} />
      </Routes>
    </Layout>
  );
}
